'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { excludeComponentProps } from '../utils/excludeComponentProps';
import { navCssClassNames } from './navCssClassNames';
import { navItemButtonCss } from './navItemButtonCss';
const StyledButton = styled(Button, excludeComponentProps('subNavigationItems', 'FlyoutContent', 'orientation', 'size', 'level', 'label', 'hasDivider'))(navItemButtonCss);
export const NavItemButton = forwardRef(({ className, orientation = 'top', ...props }, ref) => {
    return (_jsx(StyledButton, { ...props, className: clsx(navCssClassNames.itemButton, className), orientation: orientation, ref: ref, children: _jsx(Typography, { className: navCssClassNames.itemButtonText, noWrap: true, variant: 'button', children: props.children }) }));
});
NavItemButton.displayName = 'NavItemButton';
